import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ImportTimeAndAttendance } from '../models/import-time-and-attendance.model';

@Injectable({
    providedIn: 'root'
  })
export class TimeAndAttendanceImportService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/TimeAndAttendance/";
    }

    async getTimeAndAttendanceImportRawData(costCenterId: number, startDate: Date, endDate: Date): Promise<ImportTimeAndAttendance[]> {
        const params = new HttpParams()
        .set('costCenterId', costCenterId.toString())
        .set('startDate', startDate.toLocaleString())
        .set('endDate', endDate.toLocaleString());

    return await this._http.get<ImportTimeAndAttendance[]>(`${this.apiServer}GetTimeAndAttendanceImportRawData`, { params: params }).toPromise<ImportTimeAndAttendance[]>();
    }
}